module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-main",
    attrs: {
      "id": "main"
    }
  }, [(this.showControl.moreGuide && _vm.openType != 'f2e') ? _c('div', {
    staticClass: "main_tip_show",
    on: {
      "mouseover": _vm.show
    }
  }, [_c('div', {
    staticClass: "padding-tb-25",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/slider/arrow-right.png")
    },
    on: {
      "click": _vm.hide
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main_tip_space"
  }), _vm._v(" "), _c('a', {
    staticClass: "main_tip_text",
    style: ({
      'color': _vm.selectColor(this.showControl.inChat),
      'background-color': _vm.selectBgColor(this.showControl.inChat),
    }),
    on: {
      "click": _vm.contactService
    }
  }, [(_vm.selectColor(this.showControl.inChat) === 'white') ? _c('img', {
    staticClass: "main_tip_x",
    attrs: {
      "src": require("./images/slider/customer-service-white.svg")
    }
  }) : _c('img', {
    staticClass: "main_tip_x",
    attrs: {
      "src": require("./images/slider/customer-service-black.svg")
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        客服\n      ")])]), _vm._v(" "), (_vm.user.id) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('a', {
    staticClass: "main_tip_text",
    style: ({
      'color': _vm.selectColor(this.showControl.showLinkInfo),
      'background-color': _vm.selectBgColor(this.showControl.showLinkInfo),
    }),
    on: {
      "click": _vm.showLink
    }
  }, [(_vm.selectColor(this.showControl.showLinkInfo) === 'white') ? _c('img', {
    staticClass: "main_tip_x",
    attrs: {
      "src": require("./images/slider/chat-white.svg")
    }
  }) : _c('img', {
    staticClass: "main_tip_x",
    attrs: {
      "src": require("./images/slider/chat-black.svg")
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n          联系人\n        ")])]), _vm._v(" "), (this.showControl.showLinkInfo) ? _c('div', [_c('CustomerCard', {
    attrs: {
      "onClose": _vm.hideLink,
      "showCard": this.showControl.showLinkInfo
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "main_tip_text",
    style: ({
      'color': _vm.selectColor(this.showControl.showFeedback),
      'background-color': _vm.selectBgColor(this.showControl.showFeedback),
    }),
    on: {
      "click": _vm.showFeed
    }
  }, [(_vm.selectColor(this.showControl.showFeedback) === 'white') ? _c('img', {
    staticClass: "main_tip_x",
    attrs: {
      "src": require("./images/slider/feedback-white.svg")
    }
  }) : _c('img', {
    staticClass: "main_tip_x",
    attrs: {
      "src": require("./images/slider/feedback-black.svg")
    }
  }), _vm._v("\n        反馈\n      ")])]) : _vm._e()]) : (_vm.openType != 'f2e') ? _c('a', {
    staticClass: "bg1",
    on: {
      "click": _vm.show
    }
  }, [_c('Icon', {
    staticClass: "iconStyle",
    attrs: {
      "size": 30,
      "color": "white",
      "type": "ios-arrow-left"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('complaint-modal', {
    attrs: {
      "fade": this.showControl.showFeedback
    },
    on: {
      "change": _vm.hideFeed
    }
  }), _vm._v(" "), _c('CouponModal'), _vm._v(" "), _c('BlacklistModal'), _vm._v(" "), (!_vm.isShowXiniyuan) ? _c('FeeConfirmGuide') : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (this.showControl.inChat && _vm.openType != 'f2e') ? _c('chatPop', {
    ref: "chatpop",
    attrs: {
      "chatPop": true,
      "onClose": _vm.hideContactService,
      "openpage": "main"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5c320175", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c320175"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/App.vue
// module id = 1362
// module chunks = 61